var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkerHotelIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#ca03ca",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80-240v-520h40v360h340v-280h300q49.5 0 84.75 35.25T880-560v320h-40v-120H120v120H80Zm199.91-235.38q-35.29 0-59.91-24.71-24.62-24.71-24.62-60T220.09-620q24.71-24.62 60-24.62T340-619.91q24.62 24.71 24.62 60T339.91-500q-24.71 24.62-60 24.62ZM500-400h340v-160q0-33-23.5-56.5T760-640H500v240ZM280-515.38q18.54 0 31.58-13.04T324.62-560q0-18.54-13.04-31.58T280-604.62q-18.54 0-31.58 13.04T235.38-560q0 18.54 13.04 31.58T280-515.38Zm0-44.62Zm220-80v240-240Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerHotelIcon);
export default __webpack_public_path__ + "static/media/marker-hotel-icon.ddc3294d4fa31e3c7d1b7644d7a32ca1.svg";
export { ForwardRef as ReactComponent };